import { gql } from '@apollo/client'

export const SubContactCoreFields = gql`
  fragment SubContactCoreFields on Contact {
    __typename
    abn
    acn
    additionalEmails {
      email
      label {
        id
        isEditable
        labelText
        type
      }
    }
    additionalPhones {
      phone
      label {
        id
        isEditable
        labelText
        type
      }
    }
    address {
      country
      postcode
      state
      street
      suburb
    }
    businessName
    contactType
    email {
      email
      label {
        id
        isEditable
        labelText
        type
      }
    }
    firstName
    icon {
      colour
      images {
        size
        url
      }
      letter
    }
    id
    jobTitle
    lastName
    phone
    phoneV2 {
      phone
      label {
        id
        isEditable
        labelText
        type
      }
    }
    website
    location
    locationAccuracy
    category
    subcategory
    subcategoryUuid
  }
`

export const ContactCoreFields = gql`
  ${SubContactCoreFields}
  fragment ContactCoreFields on Contact {
    __typename
    abn
    acn
    additionalEmails {
      email
      label {
        id
        isEditable
        labelText
        type
      }
    }
    additionalPhones {
      phone
      label {
        id
        isEditable
        labelText
        type
      }
    }
    address {
      country
      postcode
      state
      street
      suburb
    }
    businessName
    contacts {
      ...SubContactCoreFields
    }
    contactType
    email {
      email
      label {
        id
        isEditable
        labelText
        type
      }
    }
    firstName
    icon {
      colour
      images {
        size
        url
      }
      letter
    }
    id
    jobTitle
    lastName
    notes
    isSelf
    paymentInstruments {
      id
      bankAccountDetails {
        account
        bsb
        name
      }

      details {
        ... on PaymentInstrumentBpayStaticCrnDetails {
          __typename
          billerName
          billerCode
          nickname
          crn
        }
        ... on PaymentInstrumentBpayDynamicCrnDetails {
          __typename
          billerName
          billerCode
          nickname
        }
      }
      status
    }
    phone
    phoneV2 {
      phone
      label {
        id
        isEditable
        labelText
        type
      }
    }
    tags
    website
    location
    locationAccuracy
    category
    subcategory
    subcategoryUuid
  }
`

export const GetContacts = gql`
  ${ContactCoreFields}
  query GetContacts(
    $contactType: ContactType
    $limit: Int!
    $filter: ContactFilterInput
    $nextToken: String
  ) {
    getContacts(
      contactType: $contactType
      limit: $limit
      filter: $filter
      nextToken: $nextToken
    ) {
      contacts {
        ...ContactCoreFields
      }
      nextToken
    }
  }
`

export const GetContactImageUploadForm = gql`
  query GetContactImageUploadForm($contactUuid: ID!) {
    getContactImageUploadForm(contactUuid: $contactUuid) {
      url
      formFields
    }
  }
`

export const GetContact = gql`
  ${ContactCoreFields}
  query GetContact($id: ID!) {
    getContact(id: $id) {
      ...ContactCoreFields
    }
  }
`

export const GetContactTransactionTotals = gql`
  query GetContactTransactionTotals($contactUuid: ID!, $cardholderUuid: ID) {
    getContactTransactionTotals(
      contactUuid: $contactUuid
      cardholderUuid: $cardholderUuid
    ) {
      count
      latestTimestamp
      totalAmount
    }
  }
`

export const GetInvoiceDraftContactUsage = gql`
  query GetInvoiceDraftContactUsage($contactUuid: ID!) {
    getInvoiceDraftContactUsage(contactUuid: $contactUuid)
  }
`
